import { useEffect, useState } from "react";

// Скорости проигрывания: во сколько раз быстрее матча. 30× — минута матча за 2 секунды.
export const PLAYBACK_SPEEDS = [10, 30, 60] as const;
const DEFAULT_SPEED = 1;

// Момент матча и проигрывание с момента `start`. Дошли до конца — пауза; «играть» с конца
// начинает с нуля. Скорость переключается по кругу.
export const usePlayback = (durationS: number, start: number) => {
  const [t, setT] = useState(start);
  const [playing, setPlaying] = useState(false);
  const [speedIndex, setSpeedIndex] = useState(DEFAULT_SPEED);
  const speed = PLAYBACK_SPEEDS[speedIndex] ?? PLAYBACK_SPEEDS[DEFAULT_SPEED];

  useEffect(() => {
    if (!playing) {
      return;
    }
    let previous = performance.now();
    let frame = requestAnimationFrame(function step(now) {
      const dt = Math.min(0.1, (now - previous) / 1000);
      previous = now;
      setT((current) => {
        const next = Math.min(durationS, current + dt * speed);
        if (next >= durationS) {
          setPlaying(false);
        }
        return next;
      });
      frame = requestAnimationFrame(step);
    });
    return () => {
      cancelAnimationFrame(frame);
    };
  }, [playing, durationS, speed]);

  return {
    t,
    playing,
    speed,
    seek: (value: number) => {
      setPlaying(false);
      setT(Math.max(0, Math.min(durationS, value)));
    },
    toggle: () => {
      if (!playing && t >= durationS) {
        setT(0);
      }
      setPlaying(!playing);
    },
    nextSpeed: () => {
      setSpeedIndex((speedIndex + 1) % PLAYBACK_SPEEDS.length);
    },
  };
};
